import React from 'react';
import './styles/Button.css';
import {Link} from 'react-router-dom';

const Button = (props) => {
    let classes = '';
    let prefix = 'button';

    if (props.color) {
        classes += ` ${prefix}--${props.color}`
    }

    if (props.backgroundColor) {
        classes += ` ${prefix}__background--${props.backgroundColor}`
    }

    let link = props.notLocal ? 
        <a className={`button ${classes}`} href={props.href} target={'_blank'}>
            {props.label}
        </a> : <Link className={`button ${classes}`} to={props.href || ''}>
            {props.label}
        </Link>;

        return (
            <div className={`button__container`}>
                {link}
                <div className={`button__border ${classes}`}/>
            </div>
        )
};

export default Button;